
import { Component, Vue } from "vue-property-decorator";
import { IBen } from "@/interface/IBen";
import { LisansEntity } from "@/entity/LisansEntity";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import SifreDegistirForm from "@/components/forms/SifreDegistirForm.vue";
import app from "@/main";
import {store} from "@/store";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";

@Component({
  components: { SifreDegistirForm, FormDialog }
})
export default class HesapBilgileriView extends Vue {
  // 📌 Data değişkenleri
  editingField: null | 'first_name' | 'last_name' = null;
  editedName: string = '';
  editedSurname: string = '';
  StatusCodeHelper = new StatusCodeHelper()

  // 📌 Getter'lar
  get userData(): IBen {
    return this.$store.getters.userData;
  }

  get lisanslar(): Array<LisansEntity> {
    return this.$store.getters.licenses;
  }

  // 📌 Kullanılan kullanıcı sayısı (Toplam - Kalan)
  get kullanilanKullaniciSayisi(): number {
    if (!this.userData.package) return 0;
    return this.userData.package.satin_alinmis_paket.user_count - this.userData.package.kalan_kullanici_sayisi;
  }

  // 📌 Kullanılan dosya sayısı (Toplam - Kalan)
  get kullanilanDosyaSayisi(): number {
    if (!this.userData.package) return 0;
    return this.userData.package.satin_alinmis_paket.file_count - this.userData.package.kalan_dosya_sayisi;
  }

  // 📌 Düzenleme alanını aç/kapat
  toggleEdit(field: 'first_name' | 'last_name') {
    if (this.editingField === field) {
      this.cancelEdit();
      return;
    }

    this.editingField = field;

    if (field === 'first_name') this.editedName = this.userData.first_name;
    if (field === 'last_name') this.editedSurname = this.userData.last_name;
  }

  // 📌 Düzenlemeyi iptal et
  cancelEdit() {
    this.editingField = null;
  }

  // 📌 Kaydetme işlemi
  async saveEdit(field: 'first_name' | 'last_name') {
    const value = field === 'first_name' ? this.editedName : this.editedSurname;
    StatusCodeHelper.dontShow403Alert = true

    try {
      const userId = this.userData.id;
      // API endpoint'lerini düzelt
      const endpoint = field === 'first_name'
          ? `/api/v1/user-firstname-change/${userId}`
          : `/api/v1/user-lastname-change/${userId}`;

      await app.$http.post(endpoint, {
        [field]: value
      });

      let user = store.getters.userData;
      if (!user.id) {
        let tenantList = await store.dispatch("getTenantList");
        store.commit('setTenantId', tenantList[0].tenant_id)
        user = await app.$http.get("/api/v1/ben");
        store.commit('setUser', user);
      }
      else{
        sessionStorage.removeItem('user');
        window.location.reload();
      }

      this.cancelEdit();
      this.$toast?.success('Bilgiler güncellendi');
    } catch (e: any) {
      const errorMessage = e.response?.data?.message || 'Bilinmeyen hata';


      console.error('Güncelleme hatası:', e);
      if (errorMessage) {
        this.$toast?.error(errorMessage);
      }else{
        this.$toast?.error('Güncelleme başarısız');

      }
    }
  }

  // 📌 Sayı formatlama
  formatNumber(num: number): string {
    return new Intl.NumberFormat('tr-TR').format(num);
  }

  // 📌 Disk boyutu formatlama
  formatDiskSize(sizeInMB: number): string {
    if (sizeInMB >= 1024) {
      return `${(sizeInMB / 1024).toFixed(2)} GB`;
    }
    return `${sizeInMB} MB`;
  }
}
